import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isValid, getFormValues } from 'redux-form';
import moment from 'moment-timezone';
import messages from '../../../../text/messages';
import { minutesFraction, timeObjectToMinutes, timeObjectFromMinutes } from '../../../../utilities/time';
import { updateTimesheet, submitTimesheet, saveTimeEntry, deleteTimeRecord } from '../../../../reducers/timekeeping';
import Modal from '../../../../components/modal';
import AddTimeForm from './addTimeForm';
import img from '../../../../assets/images/guitar.png';

class AddTime extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            day: null,
            modal: false,
            dayTotal: null,
            shifts: [],
            initialValues: {},
            addMode: false
        };

        this.closeModal = this.closeModal.bind(this);
        this.handleSubmitTimesheet = this.handleSubmitTimesheet.bind(this);
        this.toggleAddMode = this.toggleAddMode.bind(this);
        this.saveTime = this.saveTime.bind(this);
        this.removeTime = this.removeTime.bind(this);
        this.copySessions = this.copySessions.bind(this);
        this.renderButtons = this.renderButtons.bind(this);
        this.navigateDay = this.navigateDay.bind(this);
    }

    componentDidMount() {
        if (this.state.day !== this.props.day) {
            this.setState({ day: this.props.day });
        }
    }

    componentDidUpdate(prevProps) {
        const { day, week, modal, timelines, lastShiftProject, projects } = this.props;

        if (!day) {
            return;
        }
        const defaultProject = projects && projects[0].value;

        const { totalTime, shifts, iniValues } = timelines[week.indexOf(day)];
        const timeNotChanged =
            prevProps.day && timeObjectToMinutes(prevProps.timelines[week.indexOf(prevProps.day)].totalTime) === timeObjectToMinutes(totalTime);
        // Dont update state if shifts are not changed
        if (prevProps.day === day && timeNotChanged) {
            return;
        }

        const initialValues = { ...iniValues, project_id$new: lastShiftProject || defaultProject };
        this.setState({ day, modal, dayTotal: totalTime, shifts, initialValues });
    }

    closeModal() {
        const { close } = this.props;
        this.setState({ addMode: false });
        close();
    }

    handleSubmitTimesheet(values) {
        const { submitTimesheet, timesheet } = this.props;
        const { worker_notes } = values;

        updateTimesheet({ ...timesheet, worker_notes }, () => {
            submitTimesheet(timesheet.id);
        });
        this.closeModal();
    }

    saveTime(index) {
        const { valid, values, job, timesheet, reload, saveTimeEntry, isW2 } = this.props;
        const { day, shifts } = this.state;

        if (!valid && !index) {
            return;
        }

        if (index) {
            const shift = shifts[index];
            const start = isW2 ? timeObjectToMinutes(values[`time_in$${index}`]) : 0;
            const end = isW2 ? timeObjectToMinutes(values[`time_out$${index}`]) : (values[`hours$${index}`] || 0) * 60 + (values[`minutes$${index}`] || 0) * 1;
            const projectId = values[`project_id$${index}`];

            saveTimeEntry(
                {
                    ...shift,
                    project_id: projectId,
                    minutes: end - start,
                    time_in: moment
                        .tz(day, job.work_timezone)
                        .startOf('day')
                        .add(start, 'minutes')
                },
                () => {
                    reload();
                }
            );
        } else {
            const start = isW2 ? timeObjectToMinutes(values['time_in$new']) : 0;
            const end = isW2 ? timeObjectToMinutes(values['time_out$new']) : (values['hours$new'] || 0) * 60 + (values['minutes$new'] || 0) * 1;

            const projectId = values[`project_id$new`];
            const minutes = end - start;
            if (minutes) {
                saveTimeEntry(
                    {
                        job_id: job.id,
                        timesheet_id: timesheet.id,
                        minutes,
                        project_id: projectId,
                        time_in: moment
                            .tz(day, job.work_timezone)
                            .startOf('day')
                            .add(start, 'minutes')
                    },
                    () => {
                        reload(() => {
                            this.setState({ addMode: false });
                        });
                    }
                );
            }
        }
    }

    copySessions() {
        const { day } = this.state;
        const { week, timelines, job, reload, saveTimeEntry } = this.props;
        const dayIndex = week.indexOf(day);
        const timeLine = timelines[dayIndex - 1];

        const saves = timeLine.shifts.filter(s => s.type === 'regular').map(s => {
            const shift = { ...s, id: undefined, time_in: moment.tz(s.time_in, job.work_timezone).add(1, 'days') };
            return new Promise(resolve => {
                saveTimeEntry(shift, resolve);
            });
        });
        Promise.all(saves).then(() => reload());
    }
    removeTime(shift) {
        const { deleteTimeRecord, reload } = this.props;
        deleteTimeRecord(shift.id, () => reload());
    }

    navigateDay(dayIndex, next) {
        this.setState({ addMode: false });
        const { week, handleAddTime } = this.props;
        handleAddTime(week[dayIndex + next]);
    }

    toggleAddMode() {
        const { addMode } = this.state;
        this.setState({ addMode: !addMode });
    }
    renderButtons() {
        const { week, isMobile, hasWeekendWork } = this.props;
        const { day, dayTotal } = this.state;

        if (!week) {
            return null;
        }
        const dayIndex = week.indexOf(day);

        const next = (
            <div className="preview-submit" onClick={() => this.navigateDay(dayIndex, 1)}>
                <FormattedMessage {...messages.nextDay} />
                <span className="preview-arrow pull-right">
                    <i className="material-icons">chevron_right</i>
                </span>
            </div>
        );

        const previous = (
            <div className="preview-cancel" onClick={() => this.navigateDay(dayIndex, -1)}>
                <FormattedMessage {...messages.previousDay} />
                <span className="preview-arrow pull-left">
                    <i className="material-icons">chevron_left</i>
                </span>
            </div>
        );
        const finish = (
            <div>
                <div className="preview-submit" onClick={this.closeModal}>
                    <FormattedMessage {...messages.finish} />
                </div>
                {!!timeObjectToMinutes(dayTotal) && !isMobile && <img className="finishImage" alt="finish" src={img} />}
            </div>
        );

        if (dayIndex === 0) {
            return (
                <div className="row">
                    <div className="col-xs-12">{next}</div>
                </div>
            );
        }
        if (dayIndex >= week.length - (hasWeekendWork ? 1 : 3)) {
            return isMobile ? (
                <div className="row">
                    <div className="col-xs-12 col-sm-6">{finish}</div>
                    <div className="col-xs-12 col-sm-6">{previous}</div>
                </div>
            ) : (
                <div className="row">
                    <div className="col-xs-12 col-sm-6">{previous}</div>
                    <div className="col-xs-12 col-sm-6">{finish}</div>
                </div>
            );
        }

        return isMobile ? (
            <div className="row">
                <div className="col-xs-12 col-sm-6">{next}</div>
                <div className="col-xs-12 col-sm-6">{previous}</div>
            </div>
        ) : (
            <div className="row">
                <div className="col-xs-12 col-sm-6">{previous}</div>
                <div className="col-xs-12 col-sm-6">{next}</div>
            </div>
        );
    }

    render() {
        const { day, dayTotal, initialValues, addMode, shifts } = this.state;
        const { week, values, valid, timelines, isMobile, hasWeekendWork, projects, isW2, modal } = this.props;

        const newShiftMins = values ? timeObjectToMinutes(values['time_out$new']) - timeObjectToMinutes(values['time_in$new']) : 0;
        const newShift = isW2
            ? timeObjectFromMinutes(newShiftMins > 0 ? newShiftMins : 0, false)
            : { minutes: values ? values['minutes$new'] || 0 : 0, hours: values ? values['hours$new'] || 0 : 0 };

        if (!day || !dayTotal) {
            return null;
        }

        const dayIndex = week.indexOf(day);
        const hasPrevDayShifts = dayIndex && timelines[dayIndex - 1].shifts.length;
        return (
            <div>
                <Modal
                    open={modal}
                    onClose={this.closeModal}
                    managedClose
                    size="col-sm-6 col-sm-offset-3 col-xs-12"
                    title={
                        <div className="addModal-title">
                            <b>
                                <FormattedMessage {...(isMobile ? messages.addSession : messages.addSessions)} />
                            </b>
                            <br />
                            {day.format('dddd') === 'Friday' && !hasWeekendWork ? (
                                <div>
                                    <span className="friday">
                                        <FormattedMessage {...messages.happyFriday} />
                                    </span>
                                    <span>{day.format(', MMM D')}</span>
                                </div>
                            ) : (
                                <span>{day.format('dddd, MMM D')}</span>
                            )}
                        </div>
                    }
                >
                    <div>
                        <div className="close-modal" onClick={this.closeModal}>
                            <i className="material-icons">clear</i>
                        </div>
                        <AddTimeForm
                            dayIndex={dayIndex}
                            shifts={shifts || []}
                            toggleAddMode={this.toggleAddMode}
                            saveTime={this.saveTime}
                            initialValues={initialValues}
                            dayTotal={dayTotal}
                            addMode={addMode}
                            removeTime={this.removeTime}
                            copySessions={this.copySessions}
                            hasPrevDayShifts={!!hasPrevDayShifts}
                            isMobile={isMobile}
                            projects={projects}
                            isW2={isW2}
                        />

                        {!!shifts.length && (
                            <div className="row">
                                <div className="col-xs-12">
                                    <span className="total-add-time">
                                        <FormattedMessage {...messages.totalHours} /> {parseInt(dayTotal.hours, 10)} {minutesFraction(dayTotal.minutes)} h
                                        {newShiftMins > 0 &&
                                            valid &&
                                            addMode && (
                                                <span className="text-primary">
                                                    &nbsp;+ {parseInt(newShift.hours, 10)} {minutesFraction(newShift.minutes)} h{' '}
                                                </span>
                                            )}
                                    </span>
                                </div>
                            </div>
                        )}
                        {this.renderButtons()}
                    </div>
                </Modal>
            </div>
        );
    }
}

AddTime.propTypes = {
    weekTotal: PropTypes.object,
    fromTo: PropTypes.object,
    shifts: PropTypes.array,
    timesheet: PropTypes.object,
    reload: PropTypes.func,
    hasWeekendWork: PropTypes.bool,
    lastShiftProject: PropTypes.string
};

const mapStateToProps = state => {
    return {
        valid: isValid('add-time')(state),
        values: getFormValues('add-time')(state)
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            updateTimesheet,
            submitTimesheet,
            saveTimeEntry,
            deleteTimeRecord
        },
        dispatch
    );

AddTime = connect(mapStateToProps, mapDispatchToProps)(AddTime);
export default AddTime;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/components/addTime/index.jsx